import ShipContainer from './ShipContainer'

export default ShipContainer
